<template>
  <div id="footer" class="acea-row row-middle" v-if="footerList.length > 0">
    <div
      class="item"
      :class="{ on: '/' + item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
      @click="toPage(item.url)"
    >
      <img
        class="iconfont"
        :src="'/' + item.url === $route.path ? item.icon1 : item.icon2"
      />
      <div>{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
import { getFootList } from "@api/roots";
// import $store from "../store";
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: []
    };
  },
  created: function() {
    this.getFoot();
  },
  methods: {
    // 获取底部菜单
    getFoot: function() {
      getFootList()
        .then(res => {
          this.footerList = res.data.bottom;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 页面跳转
    toPage(to) {
      if (this.checkUrl(to)) {
        window.location.href = to;
      } else {
        var shopid = localStorage.getItem("shopid");
        this.$router.push({
          path: to,
          query: { shopid: shopid }
        });
      }
    },
    //检查路径是否为url
    checkUrl(str) {
      var RegUrl = new RegExp();
      RegUrl.compile("^[A-Za-z]+://[A-Za-z0-9-_]+.[A-Za-z0-9-_%&?/.=]+$");
      if (!RegUrl.test(str)) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style scoped>
#footer .item.on {
  color: #00a64c;
}
</style>
